import React, {useEffect, useState} from "react";
import Sidebar from "../components/Sidebar";
import AddButton from "../components/AddButton";

import {registerLocale} from "react-datepicker";
import {it} from "date-fns/locale";
import "react-datepicker/dist/react-datepicker.css";

import axios from "axios";
import {toast} from "react-toastify";
import {privateApi} from "../api";
import RefreshButton from "../components/RefreshButton";

registerLocale("it", it);

// ---- TYPES ----
type BrandObject = {
    id: string;
    name: string;
}

type BrandResponse = {
    status: string;
    code: number;
    message: string;
    brands: BrandObject[];
}

function Brand() {
    localStorage.setItem("focus", "brand")
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [loading, setLoading] = useState(false);
    const [brands, setBrands] = useState<BrandObject[]>([]);
    const [selectedBrandId, setSelectedBrandId] = useState("");
    const [selectedBrandName, setSelectedBrandName] = useState("");
    const [isEditModalOpen, setIsEditModalOpen] = useState(false);

    const [brandInput, setBrandInput] = useState("");

    // ---- RESET ----
    const resetForm = () => {
        setBrandInput("");
    };

    const loadBrands = async () => {
        setLoading(true);
        try {
            const res = await privateApi.get<BrandResponse>("/cr-order-manager/v1/deviceBrand");

            setBrands(res.data.brands ?? []);
        } catch (err) {
            if (axios.isAxiosError(err)) {
                const message =
                    err.response?.data?.message ||
                    "Errore lato server";
                toast.error(message);
            } else {
                toast.error("Errore non gestito");
            }
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        loadBrands();
    }, []);

    // ---- SUBMIT ----
    const handleSubmit = async () => {
        if (brandInput.trim() === "") return toast.error("Inserisci un brand valido");

        const payload = {
            brand: brandInput
        };

        try {
            await privateApi.post("/cr-order-manager/v1/deviceBrand", payload);

            setIsModalOpen(false);
            resetForm();
            loadBrands();
        } catch (err) {
            if (axios.isAxiosError(err)) {
                const message =
                    err.response?.data?.message ||
                    "Errore lato server";
                toast.error(message);
            } else {
                toast.error("Errore non gestito");
            }
        }
    };

    const handleEdit = async () => {
        if (selectedBrandName.trim() === "") return toast.error("Inserisci un brand valido");

        const payload = {
            brandId: selectedBrandId,
            brand: selectedBrandName
        };

        try {
            await privateApi.patch("/cr-order-manager/v1/deviceBrand", payload);

            setIsEditModalOpen(false);
            loadBrands();
        } catch (err) {
            if (axios.isAxiosError(err)) {
                const message =
                    err.response?.data?.message ||
                    "Errore lato server";
                toast.error(message);
            } else {
                toast.error("Errore non gestito");
            }
        }
    };

    const handleDelete = async () => {
        if (selectedBrandName.trim() === "") return toast.error("Inserisci un brand valido");

        try {
            await privateApi.delete(`/cr-order-manager/v1/deviceBrand/${selectedBrandId}`);

            setIsEditModalOpen(false);
            loadBrands();
        } catch (err) {
            if (axios.isAxiosError(err)) {
                const message =
                    err.response?.data?.message ||
                    "Errore lato server";
                toast.error(message);
            } else {
                toast.error("Errore non gestito");
            }
        }
    };

    return (
        <>
            <Sidebar/>

            <main className="ml-64 p-6">
                <div className="flex items-center justify-between mb-6">
                    <h1 className="text-2xl font-bold">Brand</h1>
                    <div className="flex items-center gap-2">
                        <RefreshButton onClick={loadBrands}/>
                        <AddButton
                            onClick={() => {
                                resetForm();
                                setIsModalOpen(true);
                            }}
                        />
                    </div>
                </div>

                <div className="space-y-6">
                    <div className="bg-white rounded-xl shadow p-5">

                        {/*Table*/}
                        <div className="overflow-x-auto">
                            <table className="w-full text-sm text-left">

                                <thead className="text-gray-500 border-b">
                                <tr>
                                    <th className="py-2">ID</th>
                                    <th className="py-2">Nome</th>
                                </tr>
                                </thead>

                                <tbody className="divide-y">
                                {loading ? (
                                    <tr>
                                        <td
                                            colSpan={4}
                                            className="py-6 text-center text-gray-500"
                                        >
                                            Caricamento...
                                        </td>
                                    </tr>
                                ) : brands.length === 0 ? (
                                    <tr>
                                        <td
                                            colSpan={4}
                                            className="py-6 text-center text-gray-500"
                                        >
                                            Nessun brand trovato
                                        </td>
                                    </tr>
                                ) : (brands.map((brand: BrandObject) => (
                                    <tr key={brand.id} className="hover:bg-gray-50"
                                        onClick={() => {
                                            setSelectedBrandId(brand.id);
                                            setSelectedBrandName(brand.name);
                                            setIsEditModalOpen(true);
                                        }}>
                                        <td className="py-2">{brand.id}</td>
                                        <td className="py-2">{brand.name}</td>
                                    </tr>
                                )))}

                                </tbody>

                            </table>
                        </div>

                    </div>
                </div>

                {isEditModalOpen && (
                    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center">
                        <div className="bg-white rounded-xl p-6 w-full max-w-md">
                            <h2 className="text-xl font-bold mb-4">
                                Modifica Brand
                            </h2>

                            <div className="space-y-3">
                                <input className="w-full border p-2 rounded"
                                       placeholder="Nome brand"
                                       value={selectedBrandName}
                                       onChange={(e) => {
                                           setSelectedBrandName(e.target.value);
                                       }}/>
                            </div>

                            <div className="flex justify-end gap-2 mt-4">
                                <button
                                    onClick={handleDelete}
                                    className="px-4 py-2 text-white bg-red-700 rounded"
                                >
                                    Elimina
                                </button>
                                <button
                                    onClick={() => {
                                        setIsEditModalOpen(false);
                                    }}
                                    className="px-4 py-2 bg-gray-200 rounded"
                                >
                                    Annulla
                                </button>

                                <button
                                    onClick={handleEdit}
                                    className="px-4 py-2 bg-blue-900 text-white rounded"
                                >
                                    Salva
                                </button>
                            </div>
                        </div>
                    </div>
                )}

                {isModalOpen && (
                    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center">
                        <div className="bg-white rounded-xl p-6 w-full max-w-md">
                            <h2 className="text-xl font-bold mb-4">
                                Nuovo Brand
                            </h2>

                            <div className="space-y-3">
                                <input className="w-full border p-2 rounded"
                                       placeholder="Nome brand*"
                                       value={brandInput}
                                       onChange={(e) => {
                                           setBrandInput(e.target.value);
                                       }}/>
                            </div>

                            <div className="flex justify-end gap-2 mt-4">
                                <button
                                    onClick={() => {
                                        setIsModalOpen(false);
                                        resetForm();
                                    }}
                                    className="px-4 py-2 bg-gray-200 rounded"
                                >
                                    Annulla
                                </button>

                                <button
                                    onClick={handleSubmit}
                                    className="px-4 py-2 bg-blue-900 text-white rounded"
                                >
                                    Salva
                                </button>
                            </div>

                            <span>(*) Campo obbligatorio</span>
                        </div>
                    </div>
                )}
            </main>
        </>
    )
        ;
}

export default Brand;